import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import * as _ from "lodash";
import { Observable } from "rxjs";
import { map, startWith, tap } from "rxjs/operators";
import {
  GeoDevicesService,
  TipoDato,
} from "src/app/services/mapa/geodevices.service";
import { TranslateService } from "@ngx-translate/core";
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
} from "@angular/material/autocomplete";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatChipInputEvent } from "@angular/material/chips";

export interface CodigoTraduccion {
  codigo: string;
  traduccion: string;
}

@Component({
  selector: "app-seleccion-tipos-datos-modal",
  templateUrl: "./seleccion-tipos-datos-modal.component.html",
  styleUrls: ["./seleccion-tipos-datos-modal.component.scss"],
})
export class SeleccionTiposDatosModalComponent implements OnInit {
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];

  allTiposDatosCollection: TipoDato[];
  tiposDatosCollection: TipoDato[];
  tiposDatosSelected: TipoDato[] = [];
  tiposDatosCtrl = new FormControl();
  filteredTiposDatos: Observable<string[]>;
  tiposDatos: string[] = [];
  allTiposDatos: string[] = [];
  selectedData: TipoDato[] = [];

  allTiposDatosTraduccion: CodigoTraduccion[] = [];

  @ViewChild("tiposDatosInput") userInput: ElementRef<HTMLInputElement>;
  @ViewChild("auto") matAutocomplete: MatAutocomplete;

  constructor(
    private geoDevicesService: GeoDevicesService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      formMode: String;
    },
    public dialogRef: MatDialogRef<SeleccionTiposDatosModalComponent>
  ) {
    this.filteredTiposDatos = this.tiposDatosCtrl.valueChanges.pipe(
      startWith(null),
      map((tipoDato: string | null) =>
        tipoDato ? this._filter(tipoDato) : this.allTiposDatos.slice()
      )
    );
  }

  ngOnInit() {
    //this.getTiposDatos();
    this.getAllTiposDatos();
    this.getTiposDatosAgrupados();
  }

  getTiposDatosAgrupados() {
    this.geoDevicesService
      .getTiposDatos()
      .pipe(
        map((tiposDatos) => {
          let tiposDatosAgrupados = _.groupBy(
            tiposDatos,
            (group) => group.codigo
          );
          return tiposDatosAgrupados;
        }),
        //tap(res=> console.log('Tipos datos agrupados', res)),
        map((tiposDatosAgrupados) => {
          let tiposDatosToShow;
          let record: TipoDato[] = [];
          Object.entries(tiposDatosAgrupados).forEach((entry) => {
            let group: TipoDato = {
              codigo: entry[0],
              descripcion: "",
              displayField: "",
              factorDecimal: "",
              nombre: entry[0],
              nombre_es: entry[0],
              nombre_en: entry[0],
              nombreCode: "",
              unidad: "",
              uuid: "",
            };
            record.push(group);
          });
          return (tiposDatosToShow = record);
        })
      )
      .subscribe((res) => {
        this.tiposDatosCollection = res;
        this.allTiposDatos = this.tiposDatosCollection.map((dato) => {
          return dato.nombre;
        });

        this.filteredTiposDatos = this.tiposDatosCtrl.valueChanges.pipe(
          startWith(null),
          map((tipoDato: string | null) =>
            tipoDato ? this._filter(tipoDato) : this.allTiposDatos.slice()
          )
        );
      });
  }

  getAllTiposDatos() {
    this.geoDevicesService.getTiposDatos().subscribe((res) => {
      // console.log(res);
      this.allTiposDatosCollection = res;
      // crear una collection con los datos traducidos
      res.forEach((tipoDato) => {
        this.allTiposDatosTraduccion.push({
          codigo: tipoDato.codigo,
          traduccion: this.translate.instant(
            `DATA_TYPES_AND_CODES.${tipoDato.codigo}`
          ),
        });
      });
      // console.log(this.allTiposDatosTraduccion);
    });
  }

  removeTiposDatosNull(
    tiposDatosCollectionFromService: TipoDato[]
  ): TipoDato[] {
    const auxUserArray: TipoDato[] = [];
    for (const tipoDato of tiposDatosCollectionFromService) {
      if (tipoDato.nombre === null) {
        auxUserArray.push(tipoDato);
      }
    }
    return (tiposDatosCollectionFromService = _.difference(
      tiposDatosCollectionFromService,
      auxUserArray
    ));
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    //console.log(value);
    if ((value || "").trim()) {
      this.tiposDatos.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }

    this.tiposDatosCtrl.setValue(null);
  }

  remove(user: string): void {
    const index = this.tiposDatos.indexOf(user);

    if (index >= 0) {
      this.tiposDatos.splice(index, 1);
      this.tiposDatosSelected.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (!this.tiposDatos.includes(event.option.viewValue)) {
      this.tiposDatos.push(event.option.viewValue);
    }

    this.tiposDatosSelected = [];
    this.tiposDatos.forEach((chip) => {
      //obtener el codigo traducido
      let value: string;
      value = this.allTiposDatosTraduccion
        .filter((codigoTraducido) => codigoTraducido.traduccion === chip)
        .map((codigoTraducido) => codigoTraducido.codigo)
        .firstOrDefault();
      let tiposDatosModel = this.tiposDatosCollection
        .filter((tiposDatos) => {
          return tiposDatos.nombre == value;
        })
        .firstOrDefault();
      this.tiposDatosSelected.push(tiposDatosModel);
      // console.log('selected',this.tiposDatosSelected);
    });

    this.tiposDatosCtrl.setValue("");
    this.tiposDatosCtrl.reset();
    this.tiposDatosCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.allTiposDatos.filter(
      (tipoDato) => tipoDato.toLowerCase().indexOf(filterValue) === 0
    );
  }

  choseData() {
    //this.selectedData = this.tiposDatos
    // Buscar todos los tipos datos que contengan los codigos

    let selected: TipoDato[] = [];
    this.tiposDatosSelected.forEach((agrupacion) => {
      selected.push(
        ...this.allTiposDatosCollection.filter(
          (tipoDato) => tipoDato.codigo === agrupacion.codigo
        )
      );
    });
    // console.log(selected);
    this.dialogRef.close(selected);
  }
}
